import { render, staticRenderFns } from "./BiopsyResult.vue?vue&type=template&id=8c395632&scoped=true&"
import script from "./BiopsyResult.vue?vue&type=script&lang=js&"
export * from "./BiopsyResult.vue?vue&type=script&lang=js&"
import style0 from "./BiopsyResult.vue?vue&type=style&index=0&id=8c395632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c395632",
  null
  
)

export default component.exports